import { HashRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/Home';
import Services from './pages/Services';
import ProductCertification from './pages/ProductCertification';
import Form1 from './pages/certification/Form1';
import PricePage from './pages/certification/PricePage.tsx';
import Abuse from './pages/certification/Abuse.tsx';
import GenericPage from './pages/certification/GenericPage';
import Declaration from "./pages/certification/Declaration.tsx";
import ServicesCertification from "./pages/ServicesCertification.tsx";
import Certificates from "./pages/certification/Certificates.tsx";
import RegulatoryDocuments from "./pages/certification/RegulatoryDocuments.tsx";

export function AppContent() {
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        
        {/* Product Certification Routes */}
        <Route path="/product-certification" element={<ProductCertification />}>
          <Route path="form-1" element={<Form1 />} />
          <Route path="form-2" element={<GenericPage title="Հայտի ձև 2" />} />
          <Route path="scheme-1" element={<GenericPage title="Սխեմա 1" />} />
          <Route path="abuse" element={<Abuse  />} />
          <Route path="price-list" element={<PricePage />} />
          <Route path="regulatory-documents" element={<RegulatoryDocuments />} />
          <Route path="policy" element={<GenericPage title="Քաղաքականությունը և նպատակները" />} />
          <Route path="structure" element={<GenericPage title="ՍՄ կառուցվածք" />} />
          <Route path="info" element={<GenericPage title="Տեղեկատվություն" />} />
          <Route path="management-system" element={<GenericPage title="Կառավարման համակարգի փաստ ցանկ" />} />
        </Route>

        <Route path="/services" element={<ServicesCertification />}>
          <Route path="declarations" element={<Declaration  />} />
          <Route path="certificates" element={<Certificates />} />
        </Route>

        {/* Placeholders for other services */}
        <Route path="/management-certification" element={<GenericPage title="Կառավարման համակարգերի սերտիֆիկացում" />} />
        <Route path="/personnel-certification" element={<GenericPage title="Ֆիզիկական անձանց սերտիֆիկացում" />} />
        <Route path="/production-losses" element={<GenericPage title="Արտադրական կորուստների նորմատավորում" />} />
        <Route path="/lab-tests" element={<GenericPage title="Լաբորատոր փորձարկումներ" />} />
        <Route path="/consultation" element={<GenericPage title="Խորհրդատվություն" />} />

      </Routes>
    </>
  );
}

export default function App() {
  return (
    <HashRouter>
      <AppContent />
    </HashRouter>
  );
}
